export type AccountTab = 'mfa' | 'password'

export const ACCOUNT_TABS: AccountTab[] = ['mfa', 'password']

export const resolveAccountTab = (value: string | null): AccountTab =>
  value === 'password' ? 'password' : 'mfa'

export const getAccountTabIndex = (tab: AccountTab): number =>
  ACCOUNT_TABS.indexOf(tab)
